export const BASE_TRIP_STATUS = {
  NEW: {
    id: 'NEW',
    value: 'New',
  },
  NEW_ASSIGNED: {
    id: 'NEW_ASSIGNED',
    value: 'Assigned',
  },
  IN_PROGRESS_EN_ROUTE: {
    id: 'IN_PROGRESS_EN_ROUTE',
    value: 'Driver on the way',
  },
  IN_PROGRESS_ON_SITE: {
    id: 'IN_PROGRESS_ON_SITE',
    value: 'Driver arrived',
  },
  IN_PROGRESS_SAFE_ON_SITE: {
    id: 'IN_PROGRESS_SAFE_ON_SITE',
    value: 'Safe for pick up',
  },
  IN_PROGRESS_VISUAL_CONTACT: {
    id: 'IN_PROGRESS_VISUAL_CONTACT',
    value: 'Passenger Identified',
  },
  IN_PROGRESS_PASSENGER_VERIFIED: {
    id: 'IN_PROGRESS_PASSENGER_VERIFIED',
    value: 'Passenger Verified',
  },
  IN_PROGRESS_TRIP_EN_ROUTE: {
    id: 'IN_PROGRESS_TRIP_EN_ROUTE',
    value: 'En Route',
  },
  IN_PROGRESS_TRIP_DESTINATION_ON_SITE: {
    id: 'IN_PROGRESS_TRIP_DESTINATION_ON_SITE',
    value: 'Arrived at destination',
  },
  IN_PROGRESS_TRIP_DESTINATION_SAFE_ON_SITE: {
    id: 'IN_PROGRESS_TRIP_DESTINATION_SAFE_ON_SITE',
    value: 'Safe to exit',
  },
  IN_PROGRESS_TRIP_PASSENGER_DROPPED_OFF: {
    id: 'IN_PROGRESS_TRIP_PASSENGER_DROPPED_OFF',
    value: 'Passenger dropped off',
  },
  RESOLVED: {
    id: 'RESOLVED',
    value: 'Resolved',
  },
  RESOLVED_EMERGENCY: {
    id: 'RESOLVED_EMERGENCY',
    value: 'Trip emergency',
  },
  RESOLVED_ABORTED: {
    id: 'RESOLVED_ABORTED',
    value: 'Aborted',
  },
  RESOLVED_CANCELLED: {
    id: 'RESOLVED_CANCELLED',
    value: 'Cancelled',
  },
};

export const TRIP_STATUS_FILTER_OPTIONS = [
  {
    id: BASE_TRIP_STATUS.NEW.id,
    name: BASE_TRIP_STATUS.NEW.value,
  },
  {
    id: BASE_TRIP_STATUS.NEW_ASSIGNED.id,
    name: BASE_TRIP_STATUS.NEW_ASSIGNED.value,
  },
  {
    id: BASE_TRIP_STATUS.IN_PROGRESS_EN_ROUTE.id,
    name: BASE_TRIP_STATUS.IN_PROGRESS_EN_ROUTE.value,
  },
  {
    id: BASE_TRIP_STATUS.IN_PROGRESS_ON_SITE.id,
    name: BASE_TRIP_STATUS.IN_PROGRESS_ON_SITE.value,
  },
  {
    id: BASE_TRIP_STATUS.IN_PROGRESS_SAFE_ON_SITE.id,
    name: BASE_TRIP_STATUS.IN_PROGRESS_SAFE_ON_SITE.value,
  },
  {
    id: BASE_TRIP_STATUS.IN_PROGRESS_VISUAL_CONTACT.id,
    name: BASE_TRIP_STATUS.IN_PROGRESS_VISUAL_CONTACT.value,
  },
  {
    id: BASE_TRIP_STATUS.IN_PROGRESS_PASSENGER_VERIFIED.id,
    name: BASE_TRIP_STATUS.IN_PROGRESS_PASSENGER_VERIFIED.value,
  },
  {
    id: BASE_TRIP_STATUS.IN_PROGRESS_TRIP_EN_ROUTE.id,
    name: BASE_TRIP_STATUS.IN_PROGRESS_TRIP_EN_ROUTE.value,
  },
  {
    id: BASE_TRIP_STATUS.IN_PROGRESS_TRIP_DESTINATION_ON_SITE.id,
    name: BASE_TRIP_STATUS.IN_PROGRESS_TRIP_DESTINATION_ON_SITE.value,
  },
  {
    id: BASE_TRIP_STATUS.IN_PROGRESS_TRIP_DESTINATION_SAFE_ON_SITE.id,
    name: BASE_TRIP_STATUS.IN_PROGRESS_TRIP_DESTINATION_SAFE_ON_SITE.value,
  },
  {
    id: BASE_TRIP_STATUS.IN_PROGRESS_TRIP_PASSENGER_DROPPED_OFF.id,
    name: BASE_TRIP_STATUS.IN_PROGRESS_TRIP_PASSENGER_DROPPED_OFF.value,
  },
  {
    id: BASE_TRIP_STATUS.RESOLVED.id,
    name: BASE_TRIP_STATUS.RESOLVED.value,
  },
  {
    id: BASE_TRIP_STATUS.RESOLVED_EMERGENCY.id,
    name: BASE_TRIP_STATUS.RESOLVED_EMERGENCY.value,
  },
  {
    id: BASE_TRIP_STATUS.RESOLVED_ABORTED.id,
    name: BASE_TRIP_STATUS.RESOLVED_ABORTED.value,
  },
  {
    id: BASE_TRIP_STATUS.RESOLVED_CANCELLED.id,
    name: BASE_TRIP_STATUS.RESOLVED_CANCELLED.value,
  },
];

export const BASE_TRANSPORT_TYPE = {
  TRANSPORT_STANDARD: {
    id: 'TRANSPORT_STANDARD',
    value: 'Transport Standard',
  },
  TRANSPORT_SECURE: {
    id: 'TRANSPORT_SECURE',
    value: 'Transport Secure',
  },
  TRANSPORT_PROTECTION: {
    id: 'TRANSPORT_PROTECTION',
    value: 'Transport Protection',
  },
};

export const RESOLVED_STATUS = [
  BASE_TRIP_STATUS.RESOLVED.value,
  BASE_TRIP_STATUS.RESOLVED_ABORTED.value,
  BASE_TRIP_STATUS.RESOLVED_CANCELLED.value,
  BASE_TRIP_STATUS.RESOLVED_EMERGENCY.value,
];
